import { getToken } from '../../../logic/token'

export default {
  token: getToken(),
  id: undefined,
  name: '',
  login_id: '',
  block: { name: '', id: '' },
  block_id: null,
  company: '',
  avatarPath: '',
  unread: 0,
  permission: 0,
  notifications: [],
  has_approval_authority: 0,
}
